//import Flickity from 'flickity';
//import * from 'flickity-imagesloaded';
import wheel from 'wheel';
import normalizeWheel from 'normalize-wheel';
import Events from '@utilities/events';

function initSliders() {

    let carousel = [...document.querySelectorAll('[js-hook-slider]')];
    let activityslider = [...document.querySelectorAll('[js-hook-activityslider]')];

    if(carousel.length){
        new Flickity('[js-hook-slider]', {
          contain: true,
          lazyLoad : true,
          dragThreshold: 100,
          selectedAttraction: 0.15,
          friction: 0.8,
          adaptiveHeight: true,
          prevNextButtons: false,
          imagesLoaded: true
        });
    }

    if(activityslider.length){
        let num_slides = [...document.querySelectorAll('.as__slide')].length;
        let as_slider = new Flickity('[js-hook-activityslider]', {
          prevNextButtons: false,
          pageDots: false,
          freeScroll: true,
          contain: true,
          initialIndex: num_slides-1,
          selectedAttraction: 0.015
        });

        Events.$on('event::as', ()=> as_slider.select(0));

        wheel.addWheelListener(as_slider.element, event => {
            const wheelNormalized = normalizeWheel(event);
            as_slider.applyForce(-wheelNormalized.pixelX / 50);
            as_slider.startAnimation();
            as_slider.dragEnd();
        });
    }

}

// Export the navigation init function
export default initSliders;



// WEBPACK FOOTER //
// /Users/sandersturing/Sites/SD/open.test/frontend/source/utilities/slider.js